module.exports = __webpack_public_path__ + "img/check-square.75b12164.svg";